<template>
  <AnalisisComponent :params="params" />
</template>

<script>
import AnalisisComponent from "@/components/AnalisisComponent.vue";
import { getCaudalSensores } from "@/data/caudalSensoresData";

const CAUDAL_ICONS = {
  25: 'mdi-battery-medium',
  26: 'mdi-water-outline',
  27: 'mdi-water-plus-outline',
  28: 'mdi-water-minus-outline',
  30: 'mdi-clock-fast',
};

export default {
  components: { AnalisisComponent },
  data() {
    return {
      params: [
        {
          "header": "Sensores"
        },
        {
          "id": 90,
          "nombre": "Temperatura",
          "id_remote": "011B06",
          "nombre_remote": "Remote Lite Almendros",
          "group": "Sensor",
          "icon": "mdi-thermometer"
        },
        {
          "id": 91,
          "nombre": "Ph",
          "id_remote": "011B06",
          "nombre_remote": "Remote Lite Almendros",
          "group": "Sensor",
          "icon": "mdi-ph"
        },
        {
          "id": 123,
          "nombre": "Bateria Remote",
          "id_remote": "011B06",
          "nombre_remote": "Remote Lite Almendros",
          "group": "Sensor",
          "icon": "mdi-battery-80"
        },
        {
          "id": 560,
          "nombre": "Bateria Remote",
          "id_remote": "016b06",
          "nombre_remote": "Remote Lite Vid",
          "group": "Sensor",
          "icon": "mdi-battery-80"
        },
        {
          "id": 8,
          "nombre": "Anemómetro",
          "id_remote": "abcd06",
          "nombre_remote": "Remote Lite Maiz",
          "group": "Sensor",
          "icon": "mdi-wind-power"
        },
        {
          "id": 12,
          "nombre": "Bateria Remote",
          "id_remote": "abcd06",
          "nombre_remote": "Remote Lite Maiz",
          "group": "Sensor",
          "icon": "mdi-battery-80"
        },
        {
          "id": 7,
          "nombre": "Conductividad",
          "id_remote": "abcd06",
          "nombre_remote": "Remote Lite Maiz",
          "group": "Sensor",
          "icon": "mdi-electric-switch"
        },
        {
          "id": 1,
          "nombre": "Humedad",
          "id_remote": "01dd06",
          "nombre_remote": "Remote Lite Olivo",
          "group": "Sensor",
          "icon": "mdi-water-percent"
        },
        {
          "id": 3,
          "nombre": "Bateria Remote",
          "id_remote": "01dd06",
          "nombre_remote": "Remote Lite Olivo",
          "group": "Sensor",
          "icon": "mdi-battery-80"
        },
        {
          "id": 20,
          "nombre": "Bateria Remote",
          "id_remote": "010906",
          "nombre_remote": "Remote Lite Hortalizas",
          "group": "Sensor",
          "icon": "mdi-battery-80"
        },

        {
          "id": 329,
          "nombre": "Presión en cabezal",
          "group": "Sensor",
          "icon": "mdi-gauge"
        },
        ...getCaudalSensores().map(s => ({
          id: s.id,
          nombre: s.nombre_tipo_sensor,
          id_remote: s.id_remote,
          nombre_remote: s.nombre_remote,
          group: 'Contador',
          icon: CAUDAL_ICONS[s.id_tipo_sensor] || 'mdi-water',
          historico: s.historico,
          unidades: s.unidades,
        })),
      ],
    };
  },
};
</script>

<style></style>